<div class="box ml-2 mr-2">
    <div class="box-header">
    
      <div class="row flex-align-center px-3 mt-3 mb-2">
                  <div class="ml-auto">
          <!-- <label class="font-weight-500">Filters : </label>
          <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="1" class="mx-2" color="primary"
              >All Users</mat-radio-button
            >
            <mat-radio-button value="2" class="mx-2" color="primary"
              >Active</mat-radio-button
            >
            <mat-radio-button value="2" class="mx-2" color="primary"
              >Inactive</mat-radio-button
            >
          </mat-radio-group> -->
        </div>
      </div>
      <div class="grid-filter">
        <div class="actions">
          <div class="row">
             <div class="col-md-6 flex-align-center">
                         
            </div> 
            <div class="col-md-6 flex-align-center justify-md-right">
              <mat-form-field>
                <mat-label>{{'Search' | translate}}</mat-label>
                <input matInput placeholder="Placeholder" />
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
              
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="box-body">
        <mat-table class="order-summary-table" [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">
            <!-- Position Column -->
            <ng-container matColumnDef="dcNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'DC Name' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.dcLocation }} - {{element.dcName}} </mat-cell>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="address">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'Street Address' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.dcAddress }} </mat-cell>
            </ng-container>
          
            <!-- Weight Column -->
            <ng-container matColumnDef="city">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'City' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.dcCity }} </mat-cell>
            </ng-container>
          
            <!-- Symbol Column -->
            <ng-container matColumnDef="province">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'Province' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.dcProvince | uppercase }} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="details">
              <mat-header-cell *matHeaderCellDef> {{'Details' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> 
                  <button mat-icon-button matTooltip="{{'ViewDetailsTooltip' | translate}}" (click)="viewDcDetails(element)">
                <mat-icon>visibility</mat-icon>

              </button></mat-cell>
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
          
          <!-- <mat-paginator [pageSizeOptions]="[15, 30, 45]" showFirstLastButtons></mat-paginator> -->
          
    </div>
    
  </div>